import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BOAuthGuard } from "../../guards/oauth.guard";
import {
  AppPageComponent,
  AppBarExpandedTabsComponent,
  AppBarComponent,
  AppSidenavComponent,
  AppBarTitleComponent,
  AppBarActionsComponent,
} from "common";
import {
  appPageComponentDataDetail,
  appPageComponentDataMaster
} from "../../app.data";
import { UserMenuComponent } from "../../user/user-menu/user-menu.component";
import { AppPageResolver, AppSidenavResolver } from "../../app.resolver";
import { FacilityDetailsComponent } from "./features/facility-details.component/facility-details.component";
import { FacilityListComponent } from "./features/facility-list/facility-list.component";
import { AdminAppBarExpandedTabsResolver } from "../../admin/admin.resolver";
const appPageDataMaster = appPageComponentDataMaster({
  appBarTitle: "Facilities",
  sideNavItem: "facility",
});

const appPageDataDetail = appPageComponentDataDetail();

const routes: Routes = [
  {
    path: "",
    canActivate: [BOAuthGuard],
    children: [
      {
        path: "admin/facilities",
        component: AppPageComponent,
        data: appPageDataMaster,
        resolve: {
          appBarExpandedTabs: AdminAppBarExpandedTabsResolver,
          appPage: AppPageResolver,
          appSidenav: AppSidenavResolver
        },
        children: [
          {
            path: "",
            outlet: "sidenav-content",
            component: AppSidenavComponent
          },
          {
            path: "",
            component: AppBarComponent,
            outlet: "app-bar",
            children: [
              {
                path: "",
                outlet: "title",
                component: AppBarTitleComponent
              },
              {
                path: "",
                outlet: "right",
                component: UserMenuComponent
              },
              {
                path: '',
                outlet: 'expanded',
                component: AppBarExpandedTabsComponent
              }
            ],
          },
          {
            path: "",
            component: FacilityListComponent,
          },
        ],
      },      
      {
        path: "admin/facilities/:id",
        component: AppPageComponent,
        data: appPageDataDetail,
        children: [
          {
            path: "",
            component: AppBarComponent,
            outlet: "app-bar",
            children: [
              {
                path: "",
                outlet: "title",
                component: AppBarTitleComponent,
              },
              {
                path: "",
                outlet: "right",
                component: AppBarActionsComponent,
              },
            ],
          },
          {
            path: "",
            component: FacilityDetailsComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FacilitiesRoutingModule { }
